module.exports = __webpack_public_path__ + "media/ad_preview/newsfeed-person-04636e6f.jpg";